import { Meta } from '@solidjs/meta';
import { RouteDefinition, useNavigate } from '@solidjs/router';

export interface IRoutesProvider 
{
	routes(): RouteDefinition[];
}



/* Good for most local redirects, provided permissions are OK */
export function Navigate(P)
{
	useNavigate()(P.url);
	return <></>
}


export function GeneralRedirect(P)
{
/* XXX REDIRECT POSSIBILITIES:
1. Solid Routers redirect() - currently only works in action() and event handlers. May change in time.
		Subscribed to this bug https://github.com/solidjs/solid-router/issues/429
   This method would remove an unnecessary page load.
2. Express response object ==> Tried this. Seems Solid Router has already sent headers to the client.
   This method would remove an unnecessary page load.
3. Send <meta> direct in HTML 
*/

//XXX NOTE the redirect page probably has some unnecessary extra content...
	return (
		<Meta http-equiv='refresh' content={`0; url=${P.url}`}/>
	);
}

